import api from './api'
import CallHelper from '@/helpers/call.helper'

class CurrencyService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/currency', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.currencies]
            } else {
                data = response.data.currencies
            }

            return data
        },)
    }

    async getInstance(uuid) {
        return api.get('/currency/' + uuid)
    }
}

export default new CurrencyService();
